import styled from '@emotion/styled';
import { CategoryTiles, Masthead } from '@zola/zola-ui/src/components/PreAuthV3';
import {
  LinkWrapper,
  TileWrapper,
} from '@zola/zola-ui/src/components/PreAuthV3/CategoryTile.styles';
import { ImageWrapper, Sidebar } from '@zola/zola-ui/src/components/PreAuthV3/Masthead.styles';
import { Tabs } from '@zola/zola-ui/src/components/Tabs';
import { SPACING } from '@zola/zola-ui/src/styles/emotion';
import MEDIA_QUERY_V2 from '@zola/zola-ui/src/styles/emotion/mediaQueryV2';
import { ProductName } from './utils';

export const StyledMasthead = styled(Masthead)`
  border-bottom: none;

  ${ImageWrapper}, ${Sidebar} {
    padding-top: 0;
  }
`;

export const StyledTabs = styled(Tabs)`
  .tabs-list-container {
    margin-bottom: 0 !important;
  }
  .panel-content {
    ${MEDIA_QUERY_V2.MOBILE} {
      margin: 0 !important;
    }
  }
  .tabs-list {
    margin-left: 0;
    ${MEDIA_QUERY_V2.EXCLUDE_MOBILE} {
      margin-left: ${SPACING.LG};
    }
  }
`;

export const ProductsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;

  ${MEDIA_QUERY_V2.MOBILE_XS} {
    grid-template-columns: 1fr;
  }

  ${MEDIA_QUERY_V2.DESKTOP} {
    grid-template-columns: 1fr 1fr 1fr;
  }

  ${MEDIA_QUERY_V2.DESKTOP_LG} {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
`;

export const StyledCategoryTiles = styled(CategoryTiles)`
  a {
    text-decoration: none !important;
  }

  ${LinkWrapper} {
    text-decoration: none !important;
  }

  ${TileWrapper} {
    &:hover {
      ${ProductName} {
        text-decoration: underline;
      }
    }
  }
`;
